<div class= "page">
  <div class="page__container">
    <h1 class="page__title spacing h2" translate>sms_campaigns_title</h1>
    <div class="mt-5">
    <div ngbDropdown class="d-flex flex-column dropdown_small_device custom">
      <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>sms_campaigns_tab_sent</button>
      <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
        <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
          sms_campaigns_tab_sent
        </button>
        <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
          sms_campaigns_tab_scheduled
        </button>
        <button ngbDropdownItem translate (click)="nav.select(3); dropdown.innerText = $event.target.innerText">sms_campaigns_tab_dynamic</button>
        <button ngbDropdownItem translate (click)="nav.select(4); dropdown.innerText = $event.target.innerText">sms_campaigns_tab_periodic</button>
      </div>
    </div>
    <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device spacing custom" [(activeId)]="activeId">
      <li [ngbNavItem]="1">
        <a ngbNavLink translate>sms_campaigns_tab_sent</a>
        <ng-template ngbNavContent>
          <wsb-sms-sent [user]="user"></wsb-sms-sent>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink translate>sms_campaigns_tab_scheduled</a>
        <ng-template ngbNavContent>
          <wsb-sms-scheduled></wsb-sms-scheduled>
        </ng-template>
      </li>
      <li [ngbNavItem]="3">
        <a ngbNavLink translate>sms_campaigns_tab_dynamic</a>
        <ng-template ngbNavContent>
          <wsb-sms-recurring [user]="user"></wsb-sms-recurring>
        </ng-template>
      </li>
      <li [ngbNavItem]="4">
        <a ngbNavLink translate>sms_campaigns_tab_periodic</a>
        <ng-template ngbNavContent>
          <wsb-sms-periodic [user]="user"></wsb-sms-periodic>
        </ng-template>
      </li>
    </ul>
  </div>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
</div>

